export const enum HUB {
  AGENDA = 'AgendaHubBO',
  EXPORT = 'ExportNotificationsHub'
}

export const HUB_URL = {
  [HUB.AGENDA]: '/signalr/agenda',
  [HUB.EXPORT]: '/signalr/exportnotifications',
}
